var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 100,
    viewBox: "0 0 399 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2627 13.7156C39.6053 13.7156 22.8594 30.5152 22.8594 51.2374C22.8594 71.9597 39.6053 88.7605 60.2627 88.7605C80.9201 88.7605 97.6719 71.9609 97.6719 51.2374C97.6719 30.5135 80.9189 13.7156 60.2627 13.7156ZM60.2627 82.9492C42.8036 82.9492 28.6449 68.7523 28.6449 51.2299C28.6449 33.7076 42.7977 19.5182 60.2627 19.5182C77.7277 19.5182 91.8806 33.7163 91.8806 51.2374C91.8806 68.7581 77.7202 82.9492 60.2627 82.9492Z",
    fill: "url(#paint0_linear_36781_33216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6691 31.2484L72.3645 31.0323C72.3645 31.0323 68.8861 30.6486 66.9069 34.5256C65.8121 36.6669 65.3229 37.6249 65.1043 38.0538L65.0179 38.2201H73.059L76.6691 31.2484Z",
    fill: "url(#paint1_linear_36781_33216)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6691 31.2484L72.3645 31.0323C72.3645 31.0323 68.8861 30.6486 66.9069 34.5256C65.8121 36.6669 65.3229 37.6249 65.1043 38.0538L65.0179 38.2201H73.059L76.6691 31.2484Z",
    fill: "url(#paint2_linear_36781_33216)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3667 49.7532H59.0383L55.3409 57.0699V57.0624L53.8783 60.0038L53.089 61.5936H53.1065L51.348 65.2166L50.4274 63.195L48.7333 59.429C46.8879 55.2914 43.2691 55.5113 43.2691 55.5113H38.8032L43.0745 64.9481L47.0425 73.916L47.1705 74.2111H55.5666L61.7822 60.9402L61.8101 60.8841L67.2365 49.7603H76.5157V45.5712H53.5383C52.4315 45.5733 51.3708 46.0147 50.5886 46.7986C49.8068 47.5829 49.3671 48.6452 49.3667 49.7532Z",
    fill: "url(#paint3_linear_36781_33216)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3667 49.7532H59.0383L55.3409 57.0699V57.0624L53.8783 60.0038L53.089 61.5936H53.1065L51.348 65.2166L50.4274 63.195L48.7333 59.429C46.8879 55.2914 43.2691 55.5113 43.2691 55.5113H38.8032L43.0745 64.9481L47.0425 73.916L47.1705 74.2111H55.5666L61.7822 60.9402L61.8101 60.8841L67.2365 49.7603H76.5157V45.5712H53.5383C52.4315 45.5733 51.3708 46.0147 50.5886 46.7986C49.8068 47.5829 49.3671 48.6452 49.3667 49.7532Z",
    fill: "url(#paint4_linear_36781_33216)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7989 38.9861C55.6855 38.9861 54.6177 39.4212 53.8305 40.1959C53.0433 40.9707 52.6007 42.0214 52.6003 43.1174H62.4976L61.5296 44.959H69.7178L70.6604 43.1174H79.8886V38.9861H56.7989Z",
    fill: "url(#paint5_linear_36781_33216)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7989 38.9861C55.6855 38.9861 54.6177 39.4212 53.8305 40.1959C53.0433 40.9707 52.6007 42.0214 52.6003 43.1174H62.4976L61.5296 44.959H69.7178L70.6604 43.1174H79.8886V38.9861H56.7989Z",
    fill: "url(#paint6_linear_36781_33216)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.9 48.1539H118.214V52.5628H120.9C122.522 52.5628 123.282 51.7266 123.282 50.3326C123.282 49.015 122.522 48.1539 120.9 48.1539ZM121.153 44.5554C125.512 44.5554 127.691 47.0641 127.691 50.1555C127.691 52.3853 126.475 54.4884 123.739 55.2993L127.843 62.3437H122.953L119.253 55.6289H118.214V62.3437H113.881V44.5554H121.153Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.901 48.0267H142.338V51.6252H148.141V54.9701H142.338V58.8724H148.901V62.3437H138.005V44.5554H148.901V48.0267Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M158.379 44.5554H163.016L165.575 57.5038L168.743 44.5554H173.507L176.548 57.5038L179.132 44.5554H183.794L179.157 62.3437H173.912L171.074 50.6368L168.134 62.3437H162.889L158.379 44.5554Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M201.33 49.3446L199.15 55.8566H203.534L201.33 49.3446ZM204.65 59.2016H198.011L196.946 62.3437H192.41L198.847 44.5554H203.864L210.3 62.3437H205.714L204.65 59.2016Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M226.874 48.1539H224.188V52.5628H226.874C228.495 52.5628 229.256 51.7266 229.256 50.3326C229.256 49.015 228.495 48.1539 226.874 48.1539ZM227.127 44.5554C231.486 44.5554 233.665 47.0641 233.665 50.1555C233.665 52.3853 232.448 54.4884 229.712 55.2993L233.816 62.3437H228.927L225.226 55.6289H224.188V62.3437H219.855V44.5554H227.127Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250.365 58.5931C253.633 58.5931 255.559 56.7178 255.559 53.4493C255.559 50.1805 253.633 48.2553 250.365 48.2553H248.312V58.5931H250.365ZM259.968 53.4493C259.968 58.7199 256.319 62.3437 250.643 62.3437H243.979V44.5554H250.643C256.319 44.5554 259.968 48.1539 259.968 53.4493Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.439 62.2752C272.613 62.2752 269.623 60.3749 269.496 56.7765H274.108C274.234 58.1447 275.096 58.8039 276.312 58.8039C277.579 58.8039 278.39 58.1705 278.39 57.1314C278.39 53.8372 269.496 55.611 269.547 49.3014C269.547 45.9315 272.309 44.0562 276.033 44.0562C279.91 44.0562 282.52 45.9818 282.698 49.3775H278.01C277.934 48.2374 277.123 47.5529 275.958 47.5275C274.919 47.5026 274.133 48.0346 274.133 49.1489C274.133 52.2411 282.926 50.8471 282.926 56.8022C282.926 59.7918 280.595 62.2752 276.439 62.2752Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M292.227 44.5554H305.986V48.0267H301.273V62.3437H296.94V48.0267H292.227V44.5554Z",
    fill: "#F7EF46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M318.853 62.3438H317.014C316.326 62.3438 315.767 61.7855 315.767 61.0969V45.8025C315.767 45.1138 316.326 44.5556 317.014 44.5556H318.853C319.542 44.5556 320.1 45.1138 320.1 45.8025V61.0969C320.1 61.7855 319.542 62.3438 318.853 62.3438Z",
    fill: "#F7EF46"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M339.055 44.2262C343.287 44.2262 346.48 46.6082 347.493 50.4598H342.729C341.995 48.9394 340.651 48.1792 339.005 48.1792C336.344 48.1792 334.52 50.1555 334.52 53.2977C334.52 56.4402 336.344 58.4165 339.005 58.4165C340.651 58.4165 341.995 57.6559 342.729 56.136H347.493C346.48 59.9876 343.287 62.3437 339.055 62.3437C333.81 62.3437 330.111 58.6193 330.111 53.2977C330.111 47.9768 333.81 44.2262 339.055 44.2262Z",
    fill: "#F7EF46"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M362.09 54.4884V62.3437H357.757V44.5554H362.09V52.36L368.019 44.5554H373.113L366.22 53.2719L373.366 62.3437H368.07L362.09 54.4884Z",
    fill: "#F7EF46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36781_33216",
    x1: 60.2627,
    y1: 88.7605,
    x2: 60.2627,
    y2: 13.7156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6891F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36781_33216",
    x1: 7235.7,
    y1: 2530.23,
    x2: 8162.21,
    y2: 2530.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6891F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36781_33216",
    x1: 70.8433,
    y1: 38.2201,
    x2: 70.8433,
    y2: 31.0219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6891F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36781_33216",
    x1: 16567.6,
    y1: 14880.3,
    x2: 26224.7,
    y2: 14880.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6891F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_36781_33216",
    x1: 57.658,
    y1: 74.2111,
    x2: 57.658,
    y2: 45.5712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6891F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_36781_33216",
    x1: 14565,
    y1: 2406.55,
    x2: 19596.9,
    y2: 2406.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6891F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_36781_33216",
    x1: 66.2436,
    y1: 44.959,
    x2: 66.2436,
    y2: 38.9861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6891F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EE52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89affb96c42bc16a0c6abc9e29e1091c.svg";
export { ForwardRef as ReactComponent };